// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --lightMain: #7fbab9;
  --primaryColor: #00b28d;
  --infoColor: #26a1f3;
  --dangerColor: #f44336;
  --warningColor: #ef672f;
  --black: #212121;
  --header: #075e5b;
  --header-2: #075e5b;
  --darkGreen: #007574;
  --mainYellow: #e1a900;
  --buttonYellow: #e0a900;
  --buttonYellowHover: #ca9800;
  --mainRed: #e12c4f;
  --mainWhite: #eeeeee;
  --cardBackground: #e9f5f3;
  --inputGray: #555555;
  --white: #fff;
  --greyTaskBtn: #c2c2c2;
  --black75: #474949;
  --black10: #e7e7e7;
  --shadow: rgba(0, 0, 0, 0.14);
  --black70: rgba(0, 0, 0, 0.7);
  --black90: rgba(0, 0, 0, 0.9);
  --black25: #c2c2c2;
  --iconGrey: #858585;
  /* Status filter chips: an unselected chip drops its status colour for these
     greys, so the row shows at a glance which filters are actually on. */
  --chipInactiveBorder: #d0d0d0;
  --chipInactiveText: #9e9e9e;
  --chipAllToggle: #696969;
  /* One radius for every status token - the chips, the row tokens and the
     Inquiry status selector. Read from JS as STATUS_TOKEN_RADIUS. */
  --statusTokenRadius: 5px;
}

a {
  color: var(--primaryColor);
}

a:hover {
  font-weight: bold;
}

html,
body {
  margin: 0;
  height: 100%;
  color: var(--black);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scrollbar-width: thin;
  scrollbar-color: #ca9800 transparent;
}

.niceText {
  word-break: break-all;
  hyphens: auto;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB;yEACuE;EACvE,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;EACxB;oEACkE;EAClE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EAGrB,aAAa;AACf","sourcesContent":[":root {\n  --lightMain: #7fbab9;\n  --primaryColor: #00b28d;\n  --infoColor: #26a1f3;\n  --dangerColor: #f44336;\n  --warningColor: #ef672f;\n  --black: #212121;\n  --header: #075e5b;\n  --header-2: #075e5b;\n  --darkGreen: #007574;\n  --mainYellow: #e1a900;\n  --buttonYellow: #e0a900;\n  --buttonYellowHover: #ca9800;\n  --mainRed: #e12c4f;\n  --mainWhite: #eeeeee;\n  --cardBackground: #e9f5f3;\n  --inputGray: #555555;\n  --white: #fff;\n  --greyTaskBtn: #c2c2c2;\n  --black75: #474949;\n  --black10: #e7e7e7;\n  --shadow: rgba(0, 0, 0, 0.14);\n  --black70: rgba(0, 0, 0, 0.7);\n  --black90: rgba(0, 0, 0, 0.9);\n  --black25: #c2c2c2;\n  --iconGrey: #858585;\n  /* Status filter chips: an unselected chip drops its status colour for these\n     greys, so the row shows at a glance which filters are actually on. */\n  --chipInactiveBorder: #d0d0d0;\n  --chipInactiveText: #9e9e9e;\n  --chipAllToggle: #696969;\n  /* One radius for every status token - the chips, the row tokens and the\n     Inquiry status selector. Read from JS as STATUS_TOKEN_RADIUS. */\n  --statusTokenRadius: 5px;\n}\n\na {\n  color: var(--primaryColor);\n}\n\na:hover {\n  font-weight: bold;\n}\n\nhtml,\nbody {\n  margin: 0;\n  height: 100%;\n  color: var(--black);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  scrollbar-width: thin;\n  scrollbar-color: #ca9800 transparent;\n}\n\n.niceText {\n  word-break: break-all;\n  -webkit-hyphens: auto;\n  -moz-hyphens: auto;\n  hyphens: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
